import { createI18n } from 'vue-i18n';
import en from './en.json';
import es from './es.json';
import pt from './pt.json';

const SUPPORTED_LOCALES = ['en', 'pt', 'es'];

/**
 * Detects the browser language and returns a supported locale
 * Falls back to 'en' if the browser language is not supported
 */
function getBrowserLocale(): string {
  const savedLocale = localStorage.getItem('locale');
  if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale)) {
    return savedLocale;
  }

  const browserLang = navigator.language.split('-')[0] || 'en'; // Get 'en' from 'en-US'
  return SUPPORTED_LOCALES.includes(browserLang) ? browserLang : 'en';
}

export const i18n = createI18n({
  legacy: false,
  locale: getBrowserLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    pt,
  },
});

export { SUPPORTED_LOCALES };
